import * as dis2 from '../../dispossitions/dispossitions.const';
import { ACTIVITY_TYPE_OUTREACH, ACTIVITY_TYPE_OUTREACH_ID } from '../activity-type.const';
import { OTHER_FEE } from '../payamnets.const';

export const OUTREACH_SUBTYPE_REMAP = 'Re-entry Info Session';
export const OUTREACH_SUBTYPE_GENERAL = 'General Outreach';
//
export const OUTREACH_SUBTYPE_REMAP_ID = '65f062bc2d71dfb4e188013e';
export const OUTREACH_SUBTYPE_GENERAL_ID = '65f062bc2d71dfb8e188014e';

export const OTHER_OUTREACH = {
    _id: OUTREACH_SUBTYPE_GENERAL_ID,
    label: OUTREACH_SUBTYPE_GENERAL,
    defaultDisposition: dis2.OUT_OTH_OPEN_PENDING,
    dispositions: [dis2.OUT_OTH_OPEN_PENDING, dis2.OUT_OTH_COMPLETED, dis2.OUT_OTH_CANCELLED, dis2.OUT_OTH_OTHER],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const REMAP = {
    _id: OUTREACH_SUBTYPE_REMAP_ID,
    label: OUTREACH_SUBTYPE_REMAP,
    defaultDisposition: dis2.OUT_RE_OPEN_PENDING,
    dispositions: [dis2.OUT_RE_OPEN_PENDING, dis2.OUT_RE_COMPLETED, dis2.OUT_RE_CANCELED],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const OUTREACH = {
    _id: ACTIVITY_TYPE_OUTREACH_ID,
    icon: 'outreach',
    label: ACTIVITY_TYPE_OUTREACH,
    description: 'Activities that raise awareness and interest (and may also support education)',
    subTypes: [OTHER_OUTREACH, REMAP],
};
